/**
 * BlockSite Block Websites & Stay Focused
 *
 * Site blocker exposing its blocking UI to all origins.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 7.1.1.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'eiimnmioipafcokbfikbljfdeojpcgbh';
export const blocksite: ExtensionDefinition = {
  id: ID,
  name: "BlockSite Block Websites & Stay Focused",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Site blocker exposing its blocking UI to all origins.",
  signals: [
    { id: 'war-public-popup-html', kind: 'web-accessible-resource',
      description: 'Fetch public/popup.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'public/popup.html') },
    { id: 'war-activecontentblocker-js', kind: 'web-accessible-resource',
      description: 'Fetch activeContentBlocker.js, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'activeContentBlocker.js') },
  ],
};
